var map = {
	"./3_years.svg": "./resources/svg/3_years.svg",
	"./6_years.svg": "./resources/svg/6_years.svg",
	"./9_years.svg": "./resources/svg/9_years.svg",
	"./arrow.svg": "./resources/svg/arrow.svg",
	"./bang.svg": "./resources/svg/bang.svg",
	"./crown.svg": "./resources/svg/crown.svg",
	"./curl.svg": "./resources/svg/curl.svg",
	"./draw.svg": "./resources/svg/draw.svg",
	"./flowerone.svg": "./resources/svg/flowerone.svg",
	"./flowertwo.svg": "./resources/svg/flowertwo.svg",
	"./hajee-green.svg": "./resources/svg/hajee-green.svg",
	"./hajee-logo-1.svg": "./resources/svg/hajee-logo-1.svg",
	"./hajee-logo-2.svg": "./resources/svg/hajee-logo-2.svg",
	"./hajee-logo-3.svg": "./resources/svg/hajee-logo-3.svg",
	"./hajee-logo-4.svg": "./resources/svg/hajee-logo-4.svg",
	"./hajee-logo-5.svg": "./resources/svg/hajee-logo-5.svg",
	"./hajee-logo-6.svg": "./resources/svg/hajee-logo-6.svg",
	"./hajee.svg": "./resources/svg/hajee.svg",
	"./hero-image-bottom-overlay.svg": "./resources/svg/hero-image-bottom-overlay.svg",
	"./hero-image-top-overlay.svg": "./resources/svg/hero-image-top-overlay.svg",
	"./hero-visual-hajee.svg": "./resources/svg/hero-visual-hajee.svg",
	"./hero-visual-plugin.svg": "./resources/svg/hero-visual-plugin.svg",
	"./intersect.svg": "./resources/svg/intersect.svg",
	"./plugin-berry.svg": "./resources/svg/plugin-berry.svg",
	"./plugin.svg": "./resources/svg/plugin.svg",
	"./search.svg": "./resources/svg/search.svg",
	"./star.svg": "./resources/svg/star.svg",
	"./ticket.svg": "./resources/svg/ticket.svg",
	"./wing.svg": "./resources/svg/wing.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/svg sync recursive ^\\.\\/.*$";